<nav aria-label="breadcrumb">
  <ol class="breadcrumb mg-b-0">
    <li *ngFor="let item of navigationItems" class="breadcrumb-item">
      <a [href]="item.url">{{ item.label }} </a>
    </li>
  </ol>
</nav>
